<template>
  <article
    :class="{ 'load load--fill min-h-screen': isLoading }"
    class="card"
  >
    <header
      v-if="!isLoading"
      class="text-center py-3"
    >
      <h1
        class="text-grey-darkest text-lg1"
        v-text="'Text Message'"
      />
      <p v-if="sms.attributes.status === 'draft'">
        <AuthorName
          :full-name="sms.author.attributes.full_name"
          :is-a-shared-copy="sms.attributes.is_a_shared_copy"
          :sharing-union-name="sms.attributes.sharing_union_name"
        />
        created draft {{ deliveryDate }}
      </p>
      <p v-else>
        <span v-text="sms.author.attributes.full_name" /> {{ deliveryDateText }} {{ deliveryDate }}
      </p>
      <CommPopper ref="commPopper">
        <div
          slot="content"
          class="flex flex-col"
        >
          <a
            v-if="sms.attributes.status === 'delivered' || sms.attributes.status === 'archived'"
            v-can="'view-sms-recipients'"
            :href="deliveryUrl"
            v-text="'View Deliveries'"
          />
          <a
            v-if="sms.attributes.status === 'draft' || sms.attributes.status === 'scheduled'"
            v-can="'edit-sms'"
            :href="editUrl"
            v-text="'Edit'"
          />
          <a
            v-if="!sms.attributes.status === 'archived'"
            v-can="'archive-sms'"
            href="#"
            @click.prevent="$refs.commPopper.close().then($store.commit('communicationOpenArchiveSMSModal', sms))"
            v-text="'Archive'"
          />
          <a
            v-can="'share-comms'"
            href="#"
            @click.prevent="$refs.commPopper.close().then($root.openModalWithPayload('sendCommToOrganizationsModal', sms))"
            v-text="'Share with Organization'"
          />
          <a
            v-can="'delete-sms'"
            href="#"
            @click.prevent="$refs.commPopper.close().then($store.commit('communicationOpenDeleteSMSModal', sms))"
            v-text="'Delete'"
          />
        </div>
      </CommPopper>
    </header>
    <div
      v-if="!isLoading"
      class="card-content mx-auto"
    >
      <div class="rounded bg-grey-light p-8 border-2 border-grey text-center italic">
        <p v-text="sms.attributes.body" />
      </div>
      <div class="flex mt-12 mb-8 text-center">
        <div class="w-1/2">
          <strong v-text="'Recipient Groups'" />
          <ul
            v-if="sms.groupRecipients.data.length"
            class="list-reset"
          >
            <li
              v-for="group in sms.groupRecipients.data"
              :key="group.uuid"
              v-text="group.attributes.title"
            />
          </ul>
          <ul
            v-else
            class="list-reset"
          >
            <li
              class="italic"
              v-text="'Not sent to any groups'"
            />
          </ul>
        </div>
        <div class="w-1/2">
          <strong v-text="'Recipient Members'" />
          <ul
            v-if="sms.memberRecipients.data.length"
            class="list-reset"
          >
            <li
              v-for="member in sms.memberRecipients.data"
              :key="member.uuid"
              v-text="member.attributes.full_name"
            />
          </ul>
          <ul
            v-else
            class="list-reset"
          >
            <li
              class="italic"
              v-text="'Not sent to any individual memberships'"
            />
          </ul>
        </div>
      </div>
    </div>
    <ArchiveSMSModal @archived="$store.dispatch('communicationSetSMS', smsUuid)" />
    <DeleteSMSModal />
    <SendCommToOrganizationsModal />
  </article>
</template>

<script type="text/babel">
import ArchiveSMSModal from './_modals/ArchiveSMSModal'
import DeleteSMSModal from './_modals/DeleteSMSModal'
import CommPopper from './CommPopper'
import SendCommToOrganizationsModal from './_modals/SendCommToOrganizationsModal'
import AuthorName from './SharedCommunicationAuthorName'

export default {
  name: 'SMSDetails',
  components: {
    AuthorName,
    CommPopper,
    DeleteSMSModal,
    ArchiveSMSModal,
    SendCommToOrganizationsModal,
  },
  props: {
    smsUuid: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
    }
  },
  computed: {
    sms() {
      return this.$store.state.communication.sms
    },
    deliveryDate() {
      return this.sms.attributes.delivery_date
        ? this.$date.toMomentDateTimeFormat(this.sms.attributes.delivery_date)
        : 'not set'
    },
    editUrl() {
      return this.$urlGenerator.active(`communications/sms/${this.smsUuid}/edit`)
    },
    deliveryUrl() {
      return this.$urlGenerator.active(`communications/sms/${this.smsUuid}/deliveries`)
    },
    deliveryDateText() {
      return this.moment(this.sms.attributes.delivery_date).isAfter()
        ? 'scheduled for delivery on'
        : 'sent at'
    },
  },
  async mounted() {
    await this.$nextTick()

    this.isLoading = true

    this.$store.dispatch('communicationSetSMS', {
      uuid: this.smsUuid,
      includes: 'memberRecipients,groupRecipients',
    }).then(() => {
      this.isLoading = false
    })
  },
}
</script>
